import React from 'react'
import { useSelector } from 'react-redux'
import { Card } from 'transfix-ui/components/Card'
import { Box, Typography } from 'transfix-ui/core'
import { ICarrierState } from 'types/carrier'
import { IStore } from 'apps/carrier/utils/reducers'
import { DataReportedBy } from '../../DataReportedBy'
import { CompanyInformation } from './CompanyInformation'
import { ContactInformationAddressList } from './ContactInformationAddressList'
import { ContactInformationContactsList } from './ContactInformationContactsList'

export const CompanyOverview = () => {
  const { carrierDetails } = useSelector<IStore, ICarrierState>(({ carrier }) => carrier)
  const { id: carrierId = '' } = carrierDetails || {}

  return (
    <Card>
      <Box display='grid' gap='16px'>
        <div>
          <Typography variant='h3'>Company Overview</Typography>
          <DataReportedBy reporter='highway' />
        </div>
        <CompanyInformation />
        <ContactInformationAddressList carrierId={carrierId} />
        <ContactInformationContactsList carrierId={carrierId} />
      </Box>
    </Card>
  )
}
